import { ZodObject } from 'zod';

export const useSetFormFields = (zodSchema: ZodObject<any>) =>
  Object.keys(zodSchema.shape);
